export function isNumeric(e) {
    let char = String.fromCharCode(e.keyCode);
    if (/^[0-9]*$/.test(char)) return true;
    else e.preventDefault();
}
